import { InfoBox } from '@dealstack/frontend/shared/components/InfoBox/InfoBox.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';
import { MipInvestorBankAccountRiskFactorRes } from '@dealstack/shared/lib/generated';
import { List } from '@mantine/core';

interface Props {
	riskFactors: MipInvestorBankAccountRiskFactorRes[];
}

export const RiskFactorsCallout = ({ riskFactors }: Props) => {
	const tMipManage = useTranslationMipManage();

	if (riskFactors.length === 0) {
		return null;
	}

	return (
		<InfoBox
			direction="row"
			iconVariant="warning"
			rippleColor="red"
			matchBorderToRippleColor
			title={tMipManage('bank_accounts.details.risk_factors.title', {
				count: riskFactors.length,
			})}
			dataTestId={TEST_ELEMENT_IDS.MIP_MANAGE_BANK_ACCOUNT_RISK_CALLOUT}
		>
			<List
				c="dark.8"
				listStyleType="disc"
				withPadding
				style={{ paddingInlineStart: '0.5rem' }}
			>
				{riskFactors.map((factor) => (
					<List.Item key={factor.key}>{factor.message}</List.Item>
				))}
			</List>
		</InfoBox>
	);
};
